import styles from './styles.module.css';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Graph from './Graph';
import { useSearchParams } from 'react-router-dom';

type FilterType = 'upstream' | 'downstream';

const ImpactCard = ({ rtpEntryPoint }: { rtpEntryPoint: string }) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const handleViewChange = (type: FilterType) => {
    setSearchParams({ entryPoint: searchParams.get('entryPoint')!, view: type });
  };

  const isDownstream = searchParams.get('view') === 'downstream';

  return (
    <div className={styles.card}>
      <h3>Other Impacts</h3>
      <hr className={styles.hr} />
      <div className={styles.filter}>
        <span className={styles.view}>VIEW:</span>
        <RadioGroup
          row
          value={isDownstream ? 'downstream' : 'upstream'}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            handleViewChange(event.target.value as FilterType);
          }}
        >
          <FormControlLabel value="upstream" control={<Radio color="default" size="small" />} label="Upstream RTPs" />
          <FormControlLabel
            value="downstream"
            control={<Radio color="default" size="small" checked={isDownstream} />}
            label="Downstream RTPs"
          />
        </RadioGroup>
      </div>
      <Graph rtpEntryPoint={rtpEntryPoint} isUpstream={!isDownstream} />
    </div>
  );
};

export default ImpactCard;
